import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { StyledPaymentScreen } from "./styles";
import assets from "../../assets";
import { Button, Divider } from "../../components";

const CancelPaymentScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const bookingId = queryParams.get("id"); // Extract the booking ID

  const handleRetryPayment = () => {
    navigate(-1);
  };

  return (
    <StyledPaymentScreen>
      <img src={assets.DissapointmentVector} alt="" />
      <h1>Payment Canceled!</h1>
      {bookingId ? (
        <p>
          Something went wrong with processing you booking with ID:{" "}
          <strong>{bookingId}</strong>. Don't worry. It happens.
          <br />
          <strong
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={handleRetryPayment}
          >
            Please try again.
          </strong>
        </p>
      ) : (
        <p>
          Something went wrong and we could not process your payment.{" "}
          <strong
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={handleRetryPayment}
          >
            Please try again.
          </strong>
        </p>
      )}
      <Divider content="or" />
      <Button label="Keep Exploring" onClick={() => navigate("/home")} />
    </StyledPaymentScreen>
  );
};

export default CancelPaymentScreen;
